// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"07aaeaff","95":"2bc88093","189":"ef8b59c5","309":"c33b2ee8","490":"38afd549","580":"15872137","751":"531042ee","764":"362ab039","933":"9f6a3373","941":"e79edbed","942":"0c81f174"}[chunkId] + ".chunk.js";
};